export const ALL_CRM_COLUMNS = 'allCrmColumns';
export const COLUMNS_IN_VIEW_ONLY = 'columnsInViewOnly';
export const LIMITED_PRESET_COLUMNS = 'limitedPresetColumns';